import React from 'react';
import './EmployePage.css';
import { motion, Variants } from 'framer-motion';
import { Trans, useTranslation } from 'react-i18next'; 
import contactoHero from '../../../assets/7.png';

const EmployePage: React.FC = () => {

  const { t } = useTranslation();

  const fadeInUp: Variants = {
    hidden: { opacity: 0, y: 40, scale: 0.98 },
    visible: { 
      opacity: 1, 
      y: 0, 
      scale: 1, 
      transition: { duration: 0.8, ease: [0.25, 0.1, 0.25, 1] } 
    },
  };

  return (
    <motion.div
      className="contact-page-container"
      initial="hidden"
      animate="visible"
      variants={fadeInUp}
    >
      <header 
        className="contact-hero"
        style={{ backgroundImage: `url(${contactoHero})` }}
      >
        <div className="hero-overlay"></div>
      </header>
      <section className="section-join-team">
        <h2 className="join-team-title">
          <Trans i18nKey="employePage:joinTeam.title" />
        </h2>
        <p>
          <Trans 
            i18nKey="employePage:joinTeam.description"
            components={{ strong: <strong /> }}
          />
        </p>
        <br />
        <p><strong><Trans i18nKey="employePage:joinTeam.subtitle" /></strong></p>
        <a href="mailto:rrhh@villasflamingos.com">rrhh@villasflamingos.com</a>
        <br />
        <a href="tel:+529848752167">Telf: (+52) 984 875 2167</a>
      </section>
    </motion.div>
  );
};

export default EmployePage;